import { forwardRef, useEffect, useState } from 'react'

import {
    Radio,
    RadioGroup,
    Grid,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputLabel,
    Input,
    TextField,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import useHistorialClinico from '../../../hooks/useHistorialClinico';

const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="(#00) 000-0000"
            definitions={{
                '#': /[1-9]/,
            }}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const Cabecera = () => {

    const { datosMedico, dataUser, dataAvance, handleChangeClinicoMed} = useHistorialClinico()
    const { historialclinico } = datosMedico;
    // const {
    //     pLugarNacimiento,
    //     pEscolaridad,
    //     pEstadoCivil,
    //     pHijos,
    //     pTelEmergencia
    // } = datos

    return (
        <>
        {dataUser!=undefined?
        <Grid container spacing={2} p={1} style={{backgroundColor:"#FFF"}}>
            <Grid item lg={12} sm={12} xs={12} style={{ alignContent: "center" }}>
                <FormControl style={{ display: "-webkit-inline-box", WebKitBoxAlign: "center" }}>
                    <FormLabel id="demo-row-radio-buttons-group-label" style={{ marginRight: "10px" }}>Tipo de examen: </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="historialclinico,hcTipo"
                        onChange={(e) => { handleChangeClinicoMed(e) }}
                        value={historialclinico.hcTipo}
                        // defaultValue={dataUser.userGenderId}
                    >
                        <FormControlLabel value={"Ingreso"} control={<Radio/>} label="Ingreso" />
                        <FormControlLabel value={"Periodico"} control={<Radio/>} label="Periódico" />
                        <FormControlLabel value={"Promocion"} control={<Radio/>} label="Promoción" />
                        <FormControlLabel value={"Retiro"} control={<Radio/>} label="Retiro" />
                        <FormControlLabel value={"Reingreso"} control={<Radio/>} label="Reingreso" />

                    </RadioGroup>
                </FormControl>
            </Grid> 
            {/* <Grid item lg={6} sm={6} xs={12}>
                <TextField
                    autoComplete="given-name"
                    name="historialclinico,hcPuesto"
                        onChange={(e) => { handleChangeClinicoMed(e) }}
                        // value={historialclinico.hcPuesto}
                    fullWidth
                    id="hcPuesto"
                    // defaultValue={historialclinico.}
                    value={dataAvance.pPuesto}
                    disabled
                    label="Puesto"
                    autoFocus
                    variant="standard"
                />
            </Grid> */}
            <Grid item lg={6} sm={6} xs={12}>
                <TextField
                    autoComplete="given-name"
                    name="area"
                    fullWidth
                    id="area"
                    disabled
                    value={dataAvance.pPuesto}
                    label="Área de trabajo"
                    autoFocus
                    variant="standard"
                />
            </Grid>
            <Grid item lg={12} sm={12} xs={12}>
                <TextField
                    autoComplete="given-name"
                    name="historialclinico,hcAgenteAmbiental"
                    onChange={(e) => { handleChangeClinicoMed(e) }}
                    value={historialclinico.hcAgenteAmbiental}
                    fullWidth
                    id="hcAgenteAmbiental"
                    // defaultValue={historialclinico.}
                    label="Agentes ambientales del puesto:"
                    autoFocus
                    variant="standard"
                />
            </Grid>
            <Grid item lg={6} sm={6} xs={12}>
                <TextField
                    autoComplete="given-name"
                    name="No"
                    fullWidth
                    id="No"
                    defaultValue={dataAvance.paciente.userNoEmpleado}
                    label="No Empleado (si aplica)"
                    autoFocus
                    variant="standard"
                />
            </Grid>
            
        </Grid>
        :null}
       </> 
    )
}

export default Cabecera